import { Injectable, InjectionToken, inject } from '@angular/core';
import { BdUserTracker } from '@bindoc-projects/util-domain-lib';
import { AccountInfo } from '@azure/msal-node';

export const TRACKING_SERVICE = new InjectionToken<BdUserTracker>(
  'tracking.service',
);

@Injectable({
  providedIn: 'root',
})
export class BdUserTrackingService {
  private _trackers: BdUserTracker[] = [];

  constructor() {
    // TRACKING_SERVICE is a `multi: true` token, so it resolves to an array at
    // runtime; widen the token's element type to the array form here.
    const trackingService = inject<BdUserTracker[]>(
      TRACKING_SERVICE as InjectionToken<BdUserTracker[]>,
      { optional: true },
    );

    this._trackers = [];

    if (trackingService && trackingService.length > 0) {
      for (const tracker of trackingService) {
        this._trackers.push(tracker);
      }
    } else {
      console.log(`no tracker loaded`);
    }
  }

  public addAuthenticatedUserContext(accountInfo: AccountInfo | null): void {
    this._trackers.forEach((_) => _.addAuthenticatedUserContext(accountInfo));
  }

  public removeAuthenticatedUserContext(): void {
    this._trackers.forEach((_) => _.removeAuthenticatedUserContext());
  }

  public trackException(error: any): void {
    this._trackers.forEach((_) => _.trackException(error));
  }

  public trackEvent(
    error: string,
    customProperties: { [key: string]: any },
  ): void {
    this._trackers.forEach((_) => _.trackEvent(error, customProperties));
  }

  public init(accountInfo: AccountInfo | null): void {
    this._trackers.forEach((_) => _.init(accountInfo));
  }

  public destroy(): void {
    this._trackers.forEach((_) => _.destroy());
  }
}
